import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/utils/http-service.service';

@Injectable({
  providedIn: 'root'
})
export class EmitirDeclaracoesPadService {

  constructor(private service: HttpService) {
  }

  previewDeclaracao(params: {
    servidorId: number;
    forcarNadaConsta?: boolean;
    observacoes?: string;
    cpfConsulta?: string;
    processosSelecionados?: string;
  }) {
    return this.service.sendGet('pad/certidao/preview', params, 'text');
  }

  downloadDeclaracao(params: {
    servidorId: number;
    forcarNadaConsta?: boolean;
    observacoes?: string;
    cpfConsulta?: string;
    processosSelecionados?: string;
  }) {
    return this.service.sendGet('pad/certidao/download', params);
  }

  consultaProcesso(data: any) {
    return this.service.sendPost("pad/certidao/consultaProcesso", data);
  }

  compararConsultas(data: { cpf: string; servidorId?: number }) {
    return this.service.sendPost("pad/certidao/comparar-consultas", data);
  }

  getProcessosAtivos(servidorId: number) {
    return this.service.sendGet("pad/certidao/processos-ativos", { servidorId });
  }
}
